import React, { useEffect, useState, useMemo } from 'react';
import { Table, Button, Card, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import HelpControls from '@rd-web-markets/shared/dist/financialSection/HelpControls';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { WagesRow, WagesHeading } from '.';
import { apiKey, getDefaultConfig } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { Editor } from '@tinymce/tinymce-react';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { useTranslation } from 'react-i18next';
export const WagesSection = _ref => {
  let {
    claim,
    debouncedSaveClaim,
    refreshClaim,
    setClaim,
    totalPayrollCostInvalid,
    project
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [claimEmployees, setClaimEmployees] = useState(null);
  const claimId = useMemo(() => claim?.id, [claim]);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const handleTinyMce = content => {
    setClaim({
      ...claim,
      employee_notes: content
    });
  };
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId, project.id));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    getData();
  }, [dispatch, claimId]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  const handleImport = async data => {
    for (const line of data.split('\n')) {
      if (line.length === 0) {
        continue;
      }
      const lineSplit = line.split('\t');
      const newEmployee = await claimEmployeesService.create({
        claim_id: claim.id,
        claim_project_report_id: project.id,
        name: lineSplit[0],
        role: lineSplit[1],
        base_salary: (lineSplit[2] || '').replace(',', ''),
        bonus: (lineSplit[3] || '').replace(',', ''),
        pension: (lineSplit[4] || '').replace(',', ''),
        reimbursed_expenses: (lineSplit[5] || '').replace(',', '')
      });
      setClaimEmployees([...claimEmployees, newEmployee]);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-end mb-2 me-2"
  }, /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), /*#__PURE__*/React.createElement(HelpControls, {
    claim: claim,
    importProps: {
      placeholder: 'Employee Name       Employee Role       Salary       Bonus       Pension       Reimbursed Expenses',
      onSubmit: handleImport
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "pb-3"
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary"
  }, "Total Payroll Cost"), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: " ",
    className: totalPayrollCostInvalid ? 'border-warning' : null,
    onChange: e => setClaim({
      ...claim,
      [e.target.name]: e.target.value
    }),
    onBlur: debouncedSaveClaim,
    disabled: claim.financials_locked,
    name: "total_payroll_cost",
    object: claim,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    className: "table-scrollable-x"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(WagesHeading, null))), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((_, index) => {
    return /*#__PURE__*/React.createElement(WagesRow, {
      key: index,
      index: index,
      claim: claim,
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      refreshClaim: refreshClaim,
      claimEmployeesService: claimEmployeesService,
      ChangeHighlighter: ChangeHighlighter,
      FormattedNumberInput: FormattedNumberInput,
      handleError: handleError
    });
  }))), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary"
  }, t('notes')), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Editor,
    apiKey: apiKey,
    onEditorChange: e => handleTinyMce(e),
    onKeyUp: () => debouncedSaveClaim(),
    onK: true,
    disabled: claim.financials_locked,
    object: claim,
    name: "employee_notes",
    init: getDefaultConfig()
  }))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "light",
    to: `/${user.account_type}/claims/${claim.id}/financial_details/employees_activity`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: `/${user.account_type}/claims/${claim.id}/financial_details/contractors`
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))))));
};